import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@b2b/app/core/guards/auth.service';
import { SearchService as GlobalSearchService } from '@sparro/app/core/api/search/search.service';

import { CartService } from '@b2b/core/api/cart/cart.service';
import { CompetitionService } from '@b2b/core/api/competition/competition.service';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { SearchService } from '@b2b/core/api/search/search.service';
import { BookmarkService } from '@sparro/app/core/api/bookmark/bookmark.service';
import { FollowerService } from '@sparro/app/core/api/follower/follower.service';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { ToastrService } from '@sparro/app/core/helpers/toastr/toastr.service';
import { UserService } from '@sparro/core/api/user/user.service';
import { MatDrawer } from '@angular/material/sidenav';
import { ArenaCompetition } from '@sparro/app/core/models/competition.model';
import { Report } from '@sparro/app/core/models/report.model';
import { Discipline } from '@sparro/app/core/models/supertag.model';
import { User } from '@sparro/app/core/models/user.model';
import { ConfirmationDialogComponent } from '@sparro/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ReportDialogComponent } from '@sparro/app/shared/components/dialogs/report-dialog/report-dialog.component';
import { ShareDialogComponent } from '@sparro/app/shared/components/dialogs/share-dialog/share-dialog.component';
import { CartDialogComponent } from '../cart-dialog/cart-dialog.component';
import { CompetitionBottomsheetComponent } from '../competition-bottomsheet/competition-bottomsheet.component';

import { environment } from '@sparro/env/environment';
import _ from 'lodash';
import { UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { HeaderService } from '@sparro/app/core/api/header/header.service';

@Component({
  selector: 'app-multi-view',
  templateUrl: './multi-view.component.html',
  styleUrls: ['./multi-view.component.scss']
})
export class MultiViewComponent implements OnInit {
  slug: string;
  user: User;
  registration_link: string;
  submission_link: string;
  voting_link: string;
  result_link: string;
  defaultImage: string = UNI_CONSTANTS.NO_IMAGE.COMP_OR_PROJECT;

  main_slug: string;
  competition: ArenaCompetition;
  similarCompetitions: ArenaCompetition[] = [];
  modules = [];
  disciplines: Discipline[] = [];
  result_announce_date: any = null;
  text_modules = [];

  isVotingRound: boolean = false;
  isResultAnnounced: boolean = false;
  isRegistrationRound: boolean = false;
  isSubmissionRound: boolean = false;

  isSmall: boolean = false;
  isMedium: boolean = false;
  isLarge: boolean = false;
  jurorPageUrl: string = `${environment.aboutUrl}about/jurors`;

  isLoading: boolean = true;
  isError: boolean = false;
  coverScrolled: boolean = false;
  hasMembership: boolean = false;
  showFloatingShare: boolean = false;
  sharedContent: object;
  contentSectionTop: number;
  isBottomSheetOpen: boolean = false;
  coverImage: string;
  tabs: any;
  chosenTab: string = 'About';
  source: string = 'competitions';
  isCompetitions: boolean = true;
  leftSideNav: boolean = false;
  showScroll: boolean = false;

  @ViewChild('desktopViewContainer') container: ElementRef;
  @ViewChildren('tabLinks') tabLinks: QueryList<any>;
  @ViewChild('leftnav') leftnav: MatDrawer;
  @ViewChild('tabsContent') tabsContent: ElementRef;
  @ViewChild('chipSection') chipList: ElementRef;

  tabIcons = {
    text: 'icon-activities',
    prize: 'icon-award'
  };

  icons = {
    share:
      'https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/share/black_bold_48x48.svg',
    share_fill:
      'https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/share/black_fill_48x48.svg',
    bookmark:
      'https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/addtocollection/default-48x8.svg',
    bookmark_fill_default:
      'https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/addtocollection/fill-48x48.svg',
    bookmark_fill_orange:
      'https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/addtocollection/collection_fill_orange_48x48.svg'
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private detailService: CompDetailService,
    private userService: UserService,
    private competitionService: CompetitionService,
    private cartService: CartService,
    private searchService: SearchService,
    private globalSearchService: GlobalSearchService,
    private imageOptimizer: ImageOptimizerService,
    public dialog: MatDialog,
    private bottomsheet: MatBottomSheet,
    private bookmarkService: BookmarkService,
    private followerService: FollowerService,
    private toast: ToastrService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private headerService: HeaderService,
    private authService: AuthService
  ) {
    iconRegistry.addSvgIcon(
      'discussion',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/discuss_active.svg')
    );
  }

  ngOnInit(): void {
    this.headerService.setHeaderWidth('medium');
    this.globalSearchService.setActiveSearchHost('Competitions');
    this.slug = this.route.snapshot.params.comp_slug;
    this.headerService.getLeftNav().subscribe(res => {
      this.leftSideNav = res;
    });
    if (this.slug) {
      this.detailService.fetchCompetition(this.slug, competition =>
        this.setCompetitionData(competition)
      );
    }
    this.getAuthUser();
    this.getBreakpoints();
  }

  @HostListener('window:resize', [])
  getWindowSize(): void {
    this.getBreakpoints();
  }

  closeBackdrop(): void {
    this.headerService.setLeftNav(false);
    this.leftnav.toggle();
  }

  getBreakpoints(): void {
    this.isSmall = window.innerWidth <= 960 ? true : false;
    this.isLarge = window.innerWidth > 1280 ? true : false;
    this.isMedium = window.innerWidth > 960 && window.innerWidth <= 1280 ? true : false;
  }

  submitEntry(): void {
    if (this.submission_link) {
      window.open(this.submission_link, 'blank');
    } else {
      window.open(`${environment.profileUrl}submit_entry_redirect`, '_blank');
    }
  }

  getAuthUser(): void {
    this.userService.userInitialized.subscribe((initialized: boolean) => {
      if (initialized) {
        this.userService.user.subscribe((user: User) => {
          this.user = user;
          this.checkUserMembership();
        });
      }
    });
  }

  checkUserMembership(): void {
    if (
      this.user?.compMemberships?.find(compMembership => compMembership.comp_slug === this.slug)
    ) {
      const compMember = this.user?.compMemberships?.find(
        compMembership => compMembership.comp_slug === this.slug
      );
      if (compMember) {
        this.hasMembership = compMember.membership;
      }
    } else {
      this.cartService.hasActiveMembership(this.slug).subscribe((response: any) => {
        this.hasMembership = response.success;
        this.user?.compMemberships?.push({
          comp_slug: this.slug,
          membership: this.hasMembership
        });
        if (!this.user.compMemberships) {
          this.user.compMemberships = [];
        } else if (
          !this.user.compMemberships?.find(compMembership => compMembership.comp_slug === this.slug)
        ) {
          this.userService.setUser(this.user);
        }
      });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (this.container) {
      if (window.pageYOffset > this.container.nativeElement.offsetTop) {
        this.coverScrolled = true;
      } else {
        this.coverScrolled = false;
      }
    }
    if (!this.isLarge) {
      this.showScroll = Boolean(
        this.tabsContent.nativeElement.offsetWidth < this.chipList.nativeElement.offsetWidth &&
          window.innerWidth > 960
      );
      // console.log(this.tabsContent.nativeElement.offsetWidth, this.chipList.nativeElement.offsetWidth);

      this.tabsContent.nativeElement.style.overflow =
        window.innerWidth <= 960 ? 'scroll' : 'hidden';
    }
  }

  goToCart(): void {
    this.router.navigate(['./cart'], { relativeTo: this.route });
  }

  openDialog(event?: any): void {
    if (this.registration_link) {
      window.open(this.registration_link.toString(), '_blank');
    } else {
      const today = new Date();
      const todayDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000)
        .toISOString()
        .split('T')[0];
      if (this.competition.registration_deadline.start_date >= todayDate) {
        const dialogRef = this.dialog.open(CartDialogComponent, {
          maxWidth: '95vw',
          width: '527px',
          data: {
            comp_slug: null,
            upcoming_comp: this.competition.registration_deadline.start_date,
            user: this.user,
            hasMembership: this.hasMembership
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('dialog is closed');
        });
      } else {
        const dialogRef = this.dialog.open(CartDialogComponent, {
          maxWidth: '95vw',
          width: '527px',
          data: {
            comp_slug: this.competition.slug,
            upcoming_comp: null,
            user: this.user,
            hasMembership: this.hasMembership
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          // console.log('dialog is closed');
        });
      }
    }
  }

  setCompetitionData(competition: ArenaCompetition): void {
    if (competition) {
      this.isLoading = false;
      this.competition = competition;
      this.coverImage = this.renderImage(this.competition.image);
      this.updateSharedContent();
      this.detailService.setDynamicCount(this.competition.dynamic_entry_count);
      if (
        this.competition.registration_deadline?.link ||
        this.competition.registration_deadline?.starting_category?.link
      ) {
        this.registration_link = this.competition.registration_deadline?.link
          ? this.competition.registration_deadline?.link
          : this.competition.registration_deadline?.starting_category?.link
          ? this.competition.registration_deadline?.starting_category?.link
          : null;
      }
      if (this.competition.submission_deadline?.link) {
        this.submission_link = this.competition.submission_deadline.link;
      }
      this.disciplines = this.competition.disciplines;
      this._filterCompetitionRound();
      this.getSimilarCompetitions();
      if (this.competition) {
        if (this.competition.text_modules) {
          let groupByValue = _.groupBy(this.competition.text_modules, 'title');
          const ordered = {};
          _(groupByValue)
            .keys()
            .sort()
            .each(key => {
              ordered[key] = groupByValue[key];
            });
          groupByValue = ordered;
          this.getGroupBy(groupByValue, 'icon-activities');
        }
        if (this.competition.prize_modules) {
          const groupByValue = _.groupBy(this.competition.prize_modules, 'title');
          this.getGroupBy(groupByValue, 'icon-award');
        }
        if (this.competition.people_modules) {
          const groupByValue = _.groupBy(this.competition.people_modules, 'title');
          this.getGroupBy(groupByValue, 'icon-expert');
        }
        if (this.competition.deadline_modules) {
          const groupByValue = _.groupBy(this.competition.deadline_modules, 'title');
          this.getGroupBy(groupByValue, 'icon-deadline');
        }
        if (this.competition.partner_modules) {
          const groupByValue = _.groupBy(this.competition.partner_modules, 'title');
          this.getGroupBy(groupByValue, 'icon-business');
        }
        if (this.competition.dynamic_modules) {
          const groupByValue = _.groupBy(this.competition.dynamic_modules, 'title');
          this.getGroupBy(groupByValue, 'icon-money');
        }
        if (this.competition.results_module) {
          const groupByValue = _.groupBy(this.competition.results_module, 'title');
          this.getGroupBy(groupByValue, 'results');
        }
        if (this.modules.length > 0) {
          this.text_modules = this.modules[0];
        }
        const urlFragments = this.router.url.split('/');
        const lastFragment = urlFragments[urlFragments.length - 1];
        this.tabs = [
          {
            brief: this.modules.map(module => {
              // console.log(module[0].slug, lastFragment);
              if (module[0].slug === lastFragment) {
                this.chosenTab = module[0].title;
              }

              let info = {
                name: module[0].title,
                icon: module[0].icon,
                url: `${environment.competitionUrl}${this.competition.slug}/${module[0].type}/${module[0].slug}`,
                path: `${module[0].type}/${module[0].slug}`
              };

              if (info['name'] == 'Jury') {
                let count = 0;
                module.forEach(jury => {
                  count += jury.people;
                });
                info['count'] = count;
              }
              return info;
            })
          }
        ];

        if (lastFragment !== 'about' && this.chosenTab === 'About') {
          this.chosenTab =
            lastFragment === 'entries' ? 'Entries' : 'leaderboard' ? 'Leaderboard' : 'Discussions';
        }

        if (this.competition.entries) {
          this.tabs.push({
            extras: [
              {
                name: 'Entries',
                url: `${environment.competitionUrl}${this.competition.slug}/entries`,
                path: 'entries',
                icon: 'icon-registration-fill'
              },
              {
                name: 'Leaderboard',
                url: `${environment.competitionUrl}${this.competition.slug}/leaderboard`,
                path: 'leaderboard',
                icon: 'icon-score-bold'
              },
              {
                name: 'Discussions',
                url: `${environment.competitionUrl}${this.competition.slug}/discussions`,
                path: 'discussions',
                icon: 'icon-discuss-fill'
              }
            ]
          });
        } else {
          this.tabs.push({
            extras: [
              {
                name: 'Discussions',
                url: `${environment.competitionUrl}${this.competition.slug}/discussions`,
                path: 'discussions',
                icon: 'icon-discuss-fill'
              }
            ]
          });
        }
      }
    } else {
      this.router.navigate(['error'], {
        queryParams: { type: '404' }
      });
      this.isLoading = false;
      this.isError = true;
    }
  }

  getGroupBy(groupByValue, icon): void {
    const result = [];
    _.forEach(groupByValue, (value, key): void => {
      value[0]['icon'] = icon;
      result.push(value);
    });
    this.modules = [...this.modules, ...result];
  }

  getSimilarCompetitions(): void {
    this.competitionService.getSimilarCompetitions(this.competition.slug).subscribe(
      (response: any) => {
        this.similarCompetitions = response;
      },
      err => {
        console.log(err);
      }
    );
  }

  openBottomSheet(): void {
    this.isBottomSheetOpen = true;
    const bottomSheetRef = this.bottomsheet.open(CompetitionBottomsheetComponent, {
      backdropClass: 'bottomsheet-backdrop',
      data: {
        modules: this.modules,
        competition: this.competition
      }
    });

    bottomSheetRef.afterDismissed().subscribe(result => {
      this.isBottomSheetOpen = false;
      // console.log('Closed');
    });
  }

  closeBottomSheet(): void {
    this.isBottomSheetOpen = false;
    this.bottomsheet.dismiss(CompetitionBottomsheetComponent);
  }

  updateSharedContent(): void {
    this.sharedContent = {
      title: this.competition.title,
      subtitle: this.competition.tagline,
      cover_image: this.competition.image
    };
  }

  _filterCompetitionRound(): void {
    if (
      this.competition.registration_deadline === 'Closed' &&
      this.competition.submission_deadline === 'Closed' &&
      this.competition.voting_deadline !== 'Closed'
    ) {
      this.isVotingRound = true;
      this.isSubmissionRound = false;
      this.isRegistrationRound = false;
      this.isResultAnnounced = false;
    } else if (
      this.competition.registration_deadline !== 'Closed' &&
      this.competition.submission_deadline !== 'Closed'
    ) {
      this.isVotingRound = false;
      this.isSubmissionRound = true;
      this.isRegistrationRound = true;
      this.isResultAnnounced = false;
    } else if (this.competition.registration_deadline !== 'Closed') {
      this.isVotingRound = false;
      this.isRegistrationRound = true;
      this.isSubmissionRound = false;
      this.isResultAnnounced = false;
    } else if (this.competition.submission_deadline !== 'Closed') {
      this.isVotingRound = false;
      this.isRegistrationRound = false;
      this.isSubmissionRound = true;
      this.isResultAnnounced = false;
    } else {
      this.isVotingRound = false;
      this.isResultAnnounced = true;
      this.isSubmissionRound = false;
      this.isRegistrationRound = false;
    }
  }

  tabSelected(tab): void {
    this.chosenTab = tab.name;
    // This is added just for the scenario when the user changes screen size.
  }

  goToEntries(event?: any): void {
    this.router.navigate(['./entries'], { relativeTo: this.route });
    const scrollmenu = document.querySelectorAll('#scrollmenu a');
    for (let j = 0; j < scrollmenu.length; j++) {
      scrollmenu[j].classList.remove('active-route');
    }
  }

  goToComments(event?: any): void {
    this.router.navigate(['./discussions'], { relativeTo: this.route });
    const scrollmenu = document.querySelectorAll('#scrollmenu a');
    for (let j = 0; j < scrollmenu.length; j++) {
      scrollmenu[j].classList.remove('active-route');
    }
    window.scrollTo({ top: event ? event : 0, behavior: 'smooth' });
    // scrollmenu[9].classList.add('active-route')
  }

  goToLeaderboard(event?: any): void {
    this.router.navigate(['./leaderboard'], { relativeTo: this.route });
  }

  exploreMore() {
    return `${environment.competitionUrl}`;
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }

  getDisciplineFilter(discipline): void {
    // this.searchService.setSearchDiscipline(discipline);
    this.router.navigate(['search'], {
      queryParams: {
        query: discipline.name,
        timeline: 'all',
        order: 'title',
        show: 'all'
      }
    });
  }

  createReport() {
    if (!this.user) {
      this.redirectToLogin();
      return;
    } else {
      const dialogWidth = window.innerWidth <= 500 ? `90vw` : `527px`;
      const dialogRef = this.dialog.open(ReportDialogComponent, {
        width: dialogWidth,
        maxWidth: dialogWidth,
        data: {
          user: this.user,
          slug: this.competition.slug,
          source: this.source
        }
      });
      dialogRef.afterClosed().subscribe((response: any) => {
        if (response) {
          this.competition.report = response;
          this.toast.success('Report has been initiated');
        }
      });
    }
  }

  redactReport() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '420px',
      data: {
        message: `This will withdraw the report and the action cannot be undone.
        Are you sure you want to continue?`,
        okayButtonText: 'Yes'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        Report.redactReport(
          this.source,
          this.competition.slug,
          this.competition.report?.id
        ).subscribe((response: any) => {
          if (response) {
            this.competition.report = response;
            this.toast.success('Report has been redacted');
          }
        });
      }
    });
  }

  toggleBookmark() {
    if (!this.user) {
      this.redirectToLogin();
    } else {
      if (this.competition.bookmark) {
        this.bookmarkService
          .removeFromCollection(this.source, this.competition.slug, this.competition.bookmark?.id)
          .subscribe((response: any) => {
            if (response) {
              this.competition.bookmark = null;
              this.toast.success('Removed from collection');
            }
          });
      } else {
        const data = {
          user: this.user.id
        };
        this.bookmarkService.addToCollection(this.source, this.competition.slug, data).subscribe(
          (response: any) => {
            this.competition.bookmark = response;
            this.toast.success('Added to collection');
          },
          err => {
            console.log(err);
          }
        );
      }
    }
  }

  toggleFollow() {
    if (this.competition.is_following) {
      this.followerService
        .unfollow(this.source, this.competition.slug, this.competition.is_following?.id)
        .subscribe(response => {
          if (response) {
            this.competition.is_following = null;
            // this.changeDetectorRef.detectChanges();
          }
        });
    } else {
      const data = {
        follower: this.user.id
      };
      this.followerService.follow(this.source, this.competition.slug, data).subscribe(
        (response: any) => {
          // console.log(response);
          // this.changeDetectorRef.detectChanges();
          this.competition.is_following = response;
        },
        err => {
          console.log(err);
        }
      );
    }
  }

  redirectToLogin() {
    window.location.href = `${environment.loginUrl}authentication?service=sign-in&continue=${window.location.href}`;
  }

  openShareDialog() {
    const dialogRef = this.dialog.open(ShareDialogComponent, {
      data: {
        // sourceCopy: this.sourceCopy,
        slug: this.competition.slug,
        content: this.sharedContent
      }
    });
    dialogRef.afterClosed().subscribe(result => {});
  }

  scroll(direction: string): void {
    if (direction === 'left') {
      this.tabsContent.nativeElement.scrollLeft -= 150;
    } else {
      this.tabsContent.nativeElement.scrollLeft = this.tabsContent.nativeElement.scrollLeft + 150;
    }
  }
}
